import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { Input } from '@/components/ui/input'
import { SearchIcon } from 'lucide-react'
import { Settings2 } from 'lucide-react'
import { ContestCard } from '@/components/common'
import { useBookmarkStore } from '@/stores/bookmark'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { ChipSelect } from '@/components/main/contests/chip-select'
import { CategoryChip } from '@/hooks/api/use-categories'
import { Contest } from '@/types/contest'
import { useState } from 'react'
import Link from 'next/link'

function filterBookmarks(
  bookmarks: Contest[],
  chips: CategoryChip[],
  query: string
) {
  return bookmarks.filter((bookmark) => {
    const matchesCategory =
      chips.length === 0 ||
      // check intersection of bookmark.categories and chips
      bookmark?.categories?.some((category) =>
        chips.some((chip) => chip.id === String(category.id))
      )
    const matchesQuery =
      query === '' ||
      bookmark.title_th.toLowerCase().includes(query.toLowerCase())
    return matchesCategory && matchesQuery
  })
}

export function AppSidebarContent() {
  const { bookmarks } = useBookmarkStore()
  const [activeChips, setActiveChips] = useState<CategoryChip[]>([])
  const [searchQuery, setSearchQuery] = useState('')

  const handleFilterChange = (activeChips: CategoryChip[]) =>
    setActiveChips(activeChips)
  const handleSearchChange = (query: string) => setSearchQuery(query)

  const filteredBookmarks = filterBookmarks(bookmarks, activeChips, searchQuery)

  return (
    <>
      <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
      <SidebarContent>
        <SidebarGroup className="py-6">
          <Popover>
            <div className="relative">
              <SearchIcon className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
              <Input
                placeholder="ค้นหางานแข่ง"
                className="flex justify-between rounded-full py-2 pl-10 pr-4 font-line text-xs font-normal text-zinc-400 shadow-md"
                value={searchQuery}
                onChange={(e) => handleSearchChange(e.target.value)}
              />
              <PopoverTrigger className="absolute right-4 top-1/2 z-10 -translate-y-1/2">
                <Settings2 className="h-4 w-4 text-zinc-400" />
              </PopoverTrigger>
            </div>
            <PopoverContent
              align="end"
              className="z-[500] ml-4 mt-4 inline-flex min-w-80 flex-initial flex-col justify-center gap-3 rounded-md bg-white py-3 font-line text-sm font-normal text-zinc-900"
            >
              <div className="gap-2 py-1">
                <ChipSelect align="left" onFilterChange={handleFilterChange} />
              </div>
            </PopoverContent>
          </Popover>
          <div className="flex flex-col gap-4 px-2 py-6">
            {filteredBookmarks.map((item) => (
              <Link href={`/contest/${item.id}`} passHref key={item.id}>
                <ContestCard contest={item} />
              </Link>
            ))}
          </div>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
